module.exports = __webpack_public_path__ + "img/zfb.528f48b7.svg";